import { Skeleton } from 'primereact/skeleton';

/**
 * Loading placeholder shaped like a dashboard — a header, a row of stat cards,
 * then chart blocks — so the page reads as filling in rather than spinning.
 */
const DashboardSkeleton = () => (
  <div className="w-full space-y-4 p-4" data-testid="DashboardSkeleton">
    <div className="flex items-center justify-between">
      <Skeleton width="12rem" height="1.6rem" />
      <Skeleton width="8rem" height="2rem" />
    </div>

    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="space-y-2 rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
          <Skeleton width="5rem" height="0.8rem" />
          <Skeleton width="7rem" height="1.8rem" />
        </div>
      ))}
    </div>

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="space-y-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
          <Skeleton width="10rem" height="1.1rem" />
          <Skeleton height="12rem" />
        </div>
      ))}
    </div>
  </div>
);

export default DashboardSkeleton;
